<template>
  <div class="fan-inspection-page">
    <div class="layout-banner">
      <img
        :src="require('@/assets/images/product/fan_inspection_banner.png')"
        class="pc-banner"
        alt="巡风一点通-风机自动化巡检平台"
      />
      <img
        :src="require('@/assets/images/product/fan_inspection_banner.png')"
        class="mobile-banner"
        alt="巡风一点通-风机自动化巡检平台"
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          巡风一点通-风机自动化巡检平台
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          叶随风动 智能飞巡
        </div>
        <div
          class="use-button wow fadeInUp"
          data-wow-delay="0.7s"
          @click="openCodeDialog"
        >
          申请试用
        </div>
      </div>
    </div>

    <div class="block-wrap intro-wrap">
      <div class="block-title page-block-title">产品简介</div>
      <div class="block-desc page-block-desc">
        巡风一点通是集飞行任务制定、自动巡检、AI诊断、报告输出于一体的数字化管理系统。支持停机/不停机/无人化等多种巡检模式，AI自动识别雷击、裂纹等10余种缺陷，实现风机巡检的全流程自动化。
      </div>
      <div class="content-wrap">
        <div class="product-row">
          <div
            class="product-column"
            v-for="(item, index) in introList"
            :key="index"
          >
            <div class="top-img">
              <img :src="item.image" :alt="item.title" />
            </div>
            <div class="bottom-text">
              <div class="product-title">{{ item.title }}</div>
              <div class="product-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="block-wrap feature-wrap">
      <div class="block-title page-block-title">主要功能</div>
      <div class="block-content">
        <div
          class="content-row"
          v-for="(item, index) in featureList"
          :key="index"
          :class="{ reverse: index % 2 === 1 }"
        >
          <div
            class="row-media wow"
            :class="index % 2 === 0 ? 'fadeInLeft' : 'fadeInRight'"
          >
            <div class="img-wrap">
              <img :src="item.image" :alt="item.title" />
            </div>
          </div>
          <div
            class="row-text wow"
            :class="index % 2 === 0 ? 'fadeInRight' : 'fadeInLeft'"
          >
            <div class="block-text">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mask" v-if="codeDialogFlag">
      <codeCard
        @closeDialog="closeDialog"
        :codeDialogFlag="codeDialogFlag"
      ></codeCard>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import codeCard from "./components/inspection-code.vue";

export default {
  components: {
    codeCard,
  },
  data() {
    return {
      codeDialogFlag: false,
      introList: [
        {
          title: "任务制定",
          desc: "灵活制定定期/临时任务，智能规划航线，自动关联无人机",
          image: require("@/assets/images/product/fan_product-desc1.png"),
        },
        {
          title: "自动飞行",
          desc: "无人机按照预设航线自主采集叶片、塔筒、机舱影像",
          image: require("@/assets/images/product/fan_product-desc2.png"),
        },
        {
          title: "缺陷分析",
          desc: "AI自动识别雷击、裂纹、腐蚀等10余种缺陷",
          image: require("@/assets/images/product/fan_product-desc3.png"),
        },
        {
          title: "数据监控",
          desc: "电站运行状态与历史数据，实时动态分析，全盘可视",
          image: require("@/assets/images/product/fan_product-desc4.png"),
        },
      ],
      featureList: [
        {
          title: "三种模式全覆盖",
          desc: "支持停机、不停机、无人值守三种模式。停机巡检精度最高，不停机巡检零发电损失，无人值守全自动运行。一套平台灵活应对年检、日常排查、偏远风场等不同需求。",
          image: require("@/assets/images/product/function_img1_fan.png"),
        },
        {
          title: "三维环绕无死角",
          desc: "无人机自动规划三维环绕航线，对叶片前缘、后缘、叶尖、叶根多角度重叠扫描，无死角采集高清影像，杜绝视角盲区，为缺陷识别提供完整数据支撑。",
          image: require("@/assets/images/product/function_img2_fan.png"),
        },
        {
          title: "毫米级缺陷识别",
          desc: "AI算法可识别损坏、雷击、裂纹、腐蚀、胶衣脱落等10余种缺陷，能精准捕捉2mm*2mm的叶片缺陷。现场运维人员可快速定位处理，大幅缩短故障排查时间。",
          image: require("@/assets/images/product/function_img3_fan.png"),
        },
        {
          title: "无人化，零风险",
          desc: "地面远程操控或机库自主作业，无需攀爬塔筒或乘坐吊篮。配备全向避障雷达与RTK定位，支持失控返航、低电量自动返航，彻底杜绝高空作业安全隐患。",
          image: require("@/assets/images/product/function_img4_fan.png"),
        },
        {
          title: "一键操作易上手",
          desc: "系统自动规划航线，一键起飞、自动巡航、自动返航，一键生成标准化报告。普通运维人员培训1小时即可独立操作，无需专业飞手。",
          image: require("@/assets/images/product/function_img5_fan.png"),
        },
        {
          title: "数据闭环助运维",
          desc: "每次巡检自动生成缺陷清单及维修建议报告，历史数据永久归档。支持同一风机多次结果叠加对比，为预测性维护提供数据依据。",
          image: require("@/assets/images/product/function_img6_fan.png"),
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  methods: {
    closeDialog() {
      this.codeDialogFlag = false;
    },
    openCodeDialog() {
      this.codeDialogFlag = true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  z-index: 15;
  align-items: center;
}

.fan-inspection-page {
  width: 100%;

  .layout-banner {
    height: 100vh;
    position: relative;

    @keyframes zoomIn {
      0% { transform: scale(1.1); }
      100% { transform: scale(1); }
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      animation: zoomIn 3s ease-out forwards;
    }

    .pc-banner { display: block; }
    .mobile-banner { display: none; }

    .text-block {
      position: absolute;
      top: 50%;
      left: 13%;
      transform: translateY(-50%);
      z-index: 2;
      color: #fff;

      .title {
        font-size: 3rem;
        letter-spacing: 2px;
        font-weight: bold;
        margin-bottom: 1.44rem;
      }

      .desc {
        letter-spacing: 2px;
        font-size: 1.25rem;
        line-height: 35px;
      }

      .use-button {
        width: 9rem;
        height: 2.875rem;
        cursor: pointer;
        background: #2372E9;
        line-height: 2.875rem;
        text-align: center;
        margin-top: 6.18rem;
        border-radius: 30px;
      }
    }
  }

  .block-wrap {
    width: 100%;
    position: relative;
    padding-top: 4.625rem;

    .block-title {
      text-align: center;
    }

    .block-desc {
      max-width: var(--main-width);
      width: 58%;
      margin: 2.5rem auto 0;
      line-height: 2rem;
      text-align: center;
      color: #666;
      font-size: 1rem;
    }
  }

  .intro-wrap {
    background-color: #f5f7fa;
    padding-bottom: 5rem;
  }

  .content-wrap {
    max-width: var(--main-width);
    width: 84%;
    margin: 0 auto;

    .product-row {
      display: flex;
      justify-content: space-between;
      margin-top: 3.5rem;
      gap: 1.5rem;

      .product-column {
        flex: 1;
        min-width: 0;
        background: #fff;
        overflow: hidden;
      }

      .top-img {
        width: 100%;
        height: 12.25rem;
        overflow: hidden;
        background: #e6e6e6;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }

      .bottom-text {
        padding: 1.25rem 1rem 1.75rem;
        text-align: center;

        .product-title {
          margin-bottom: 0.625rem;
          font-size: 1.375rem;
          font-weight: bold;
          color: #333;
        }

        .product-desc {
          color: #666;
          font-size: 0.875rem;
          line-height: 1.5rem;
        }
      }
    }
  }

  .feature-wrap {
    padding-bottom: 4rem;

    .block-content {
      max-width: var(--main-width);
      width: 84%;
      margin: 4.5rem auto 0;
    }

    .content-row {
      display: flex;
      align-items: center;
      margin-bottom: 4rem;
      gap: 2rem;

      &.reverse {
        flex-direction: row-reverse;
      }

      .row-media,
      .row-text {
        flex: 1;
        min-width: 0;
      }

      .img-wrap {
        width: 100%;
        overflow: hidden;

        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .block-text {
        padding: 1rem 2.5rem;

        .title {
          color: #2372E9;
          margin-bottom: 1.5rem;
          font-size: 1.75rem;
          font-weight: bold;
        }

        .desc {
          color: #333;
          line-height: 1.875rem;
          font-size: 1rem;
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) and (min-width: 769px) {
  .fan-inspection-page {
    .content-wrap {
      .product-row {
        flex-wrap: wrap;

        .product-column {
          flex: 0 0 calc(50% - 0.75rem);
        }
      }
    }

    .feature-wrap {
      .content-row {
        flex-wrap: wrap;

        &.reverse {
          flex-direction: column;
        }

        .row-media,
        .row-text {
          flex: 0 0 100%;
        }

        .block-text {
          padding: 1.5rem 0 0;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .fan-inspection-page {
    .layout-banner {
      height: 380px;
      margin-top: 108px;

      .pc-banner { display: none; }
      .mobile-banner { display: block; }

      .text-block {
        left: 5%;
        right: 5%;
        top: 70px;
        transform: none;

        .title {
          font-size: 22px;
          margin-bottom: 10px;
        }

        .desc {
          font-size: 14px;
          line-height: 22px;
        }

        .use-button {
          display: none;
        }
      }
    }

    .block-wrap {
      padding: 30px 15px 0;

      .block-desc {
        width: 100%;
        margin-top: 16px;
        font-size: 14px;
        line-height: 22px;
        text-align: left;
      }
    }

    .intro-wrap {
      padding-bottom: 30px;
    }

    .content-wrap {
      width: 100%;

      .product-row {
        flex-direction: column;
        margin-top: 20px;
        gap: 16px;

        .product-column {
          width: 100%;
        }

        .top-img {
          height: 180px;
        }
      }
    }

    .feature-wrap {
      padding-bottom: 30px;

      .block-content {
        width: 100%;
        margin-top: 24px;
      }

      .content-row {
        flex-direction: column;
        margin-bottom: 28px;
        gap: 12px;

        &.reverse {
          flex-direction: column;
        }

        .block-text {
          padding: 0;

          .title {
            font-size: 18px;
            margin-bottom: 10px;
          }

          .desc {
            font-size: 14px;
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>
